export default __webpack_public_path__ + "static/media/Contact.cb57fbfc.jpeg";